import Message from "./Message.js";

export default class Chat {
  constructor(
    chatId,
    chatType,
    interlocutor,
    lastMessage
  ) {
    this.chatId = chatId;
    this.chatType = chatType;
    this.interlocutor = interlocutor;
    this.lastMessage = lastMessage;
  }

  static fromJson(json) {
    if (!json) return null;

    return new Chat(
      json.chat_id,
      json.chat_type,
      json.interlocutor,
      Message.fromJson(json.last_message)
    );
  }

  get previewText() {
    return this.lastMessage?.previewText || "Нет сообщений";
  }
}